import { render, staticRenderFns } from "./modalAddEditChangelog.vue?vue&type=template&id=13d81b20&scoped=true&"
import script from "./modalAddEditChangelog.vue?vue&type=script&lang=js&"
export * from "./modalAddEditChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d81b20",
  null
  
)

export default component.exports